<template>
  <div>
    <section class="hero is-primary">
      <div class="container">
        <nav
          class="breadcrumb is-small"
          aria-label="breadcrumbs"
        >
          <ul>
            <li>
              <router-link :to="{ name: 'home' }">
                Home
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'playlists' }">
                Playlists
              </router-link>
            </li>
            <li class="is-active">
              <a
                href="#"
                aria-current="page"
              >New</a>
            </li>
          </ul>
        </nav>
      </div>
    </section>
    <section class="section">
      <div class="container">
        <playlist-edit @update="updatePlaylistElement($event)" />
      </div>
    </section>
    <BaseActionRoundButton
      :icon-class="buttonActionIconClass"
      @click="save()"
    />
  </div>
</template>

<script>
import PlaylistEdit from "../components/PlaylistEdit";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    PlaylistEdit
  },
  data() {
    return {
      buttonActionIconClass: "fas fa-check"
    };
  },
  computed: {
    ...mapState("playlistTemplates", ["current"])
  },
  mounted() {
    this.clearCurrentPlaylist();
  },
  methods: {
    save() {
      this.createPlaylist().then(response => {
        const id = response.data.id;
        this.$router.push({
          name: "playlist",
          params: { playlistId: id },
          query: { edit: "true" }
        });
      });
    },
    ...mapActions([
      "updatePlaylistElement",
      "createPlaylist",
      "clearCurrentPlaylist"
    ])
  }
};
</script>

<style lang="scss">
.save {
  @include action-button();
}
</style>



// WEBPACK FOOTER //
// NewPlaylist.vue?06d5050a